import { categories } from '@/mocks/home';
import Reveal from '@/pages/home/components/Reveal';
import SectionHeading from '@/pages/home/components/SectionHeading';

type CategoryNavProps = {
  query: string;
};

export default function CategoryNav({ query }: CategoryNavProps) {
  const keyword = query.trim().toLowerCase();
  const list = keyword
    ? categories.filter(
        (item) =>
          item.name.toLowerCase().includes(keyword) || item.desc.toLowerCase().includes(keyword),
      )
    : categories;

  return (
    <section id="category" className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
            <SectionHeading
              eyebrow="栏目分类"
              icon="ri-list-check-2"
              title="先选方向，再进栏目"
              desc="栏目是站点的第一层入口。每个栏目对应一个内容方向，点进去就能看到该方向下的专题与标签，不用先浏览全部内容。"
            />
            <p className="shrink-0 text-xs text-foreground-500 md:text-sm">
              共 <span className="font-semibold text-primary-600">{categories.length}</span> 个栏目
            </p>
          </div>
        </Reveal>

        {list.length === 0 ? (
          <div className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-12 text-center">
            <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-background-100 text-foreground-400">
              <i className="ri-search-eye-line text-xl"></i>
            </span>
            <p className="mt-3 text-sm text-foreground-600">
              没有匹配「{query}」的栏目，换个关键词试试，或直接查看标签目录。
            </p>
            <a
              href="#tags"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              去标签目录
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        ) : (
          <div className="mt-9 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {list.map((item, index) => (
              <Reveal key={item.id} delay={index * 40}>
                <a
                  href="#tags"
                  className="card-hover group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                      <i className={`${item.icon} text-xl`}></i>
                    </span>
                    <span className="rounded-full bg-secondary-50 px-2.5 py-1 text-[11px] text-secondary-900">
                      {item.count} 条
                    </span>
                  </div>
                  <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950">
                    {item.name}
                  </h3>
                  <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                    进入栏目
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </a>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}